export const VideoBackground = () => {
  return (
    <video
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      poster="/videos/background-poster.jpg"
      className="background-video"
    >
      <source src="/videos/background.mp4" type="video/mp4" />
    </video>
  );
};
